import { Theme, withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

const checkBoxStyles = (theme: Theme) => ({
    root: {
        borderRadius: "16px",
        '&$checked': {
            color: theme.palette.primary.main,
        },
    },
    checked: {},
})

export const SubscriptionCheckbox = withStyles(checkBoxStyles)(Checkbox);